import { getProductsBySlug } from '@/api/products/productsBySlug';
import { getWordPressProductSlugs } from '@/api/products/wordPressProductSlugs';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { NotFoundError } from '@/utils/handleSSRError';
import type { FallbackProps, StaticProps } from '@gik/core/api/BaseAPIConfig';
import { baseFallback } from '@gik/core/api/BaseAPIConfig';
import type { Product } from '@gik/core/models/gik/Product';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { ProductPage } from '@gik/shop/pages/ProductPage/ProductPage';
import type { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import React from 'react';
import { SWRConfig } from 'swr';

export default function ProductPageWrapper({ fallback }: FallbackProps): JSX.Element {
  const router = useRouter();
  const inkindRouteId = router.query.routeId as string;

  // if (router.isFallback) {
  //   // TODO: wrap each page with withFallback function
  //   return <div>Loading...</div>;
  // }
  const slug = router.query.slug as string;

  // TODO: if no fallback, return <NotFoundPage />;
  return (
    <SWRConfig value={{ fallback }}>
      <ProductPage productSlug={slug} inkindRouteId={inkindRouteId} />
    </SWRConfig>
  );
}

ProductPageWrapper.getLayout = function getLayout(page: React.ReactElement, layoutProps: PageLayoutProps) {
  return <PageLayout {...layoutProps}>{page}</PageLayout>;
};

async function _getStaticProps(context: GetServerSidePropsContext): Promise<StaticProps<Product[]>> {
  const slug = context.params.slug as string;

  // Temporarily do not request similar products from ISR calls in case of crawler spam
  const [productsBySlug /*, similarProducts*/] = await Promise.all([
    getProductsBySlug({ slug: [slug], perPage: 1 }),
    // getSimilarProducts({ similarTo: slug, perPage: 4 }),
  ]);

  const products = await productsBySlug.json;

  if (!products?.length) {
    throw new NotFoundError();
  }

  return baseFallback({
    [productsBySlug.key]: products,
    //[similarProducts.key]: await similarProducts.json,
  });
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps, 'Product Page'));

export async function getStaticPaths() {
  // cache all the products at build time
  let paths = [];
  if (process.env.RENDER_STATIC_PAGES_AT_BUILD_TIME === 'true') {
    const products = await getWordPressProductSlugs();
    paths = products.map(product => ({
      params: { slug: product.slug },
    }));
  }

  return { paths, fallback: 'blocking' };
}
